import React from "react";
import PhoneInput from "./PhoneInput";

const LandlordPetsStep = ({
  isCurrentlyRenting,
  onIsCurrentlyRentingChange,
  hasPreviouslyRented,
  onHasPreviouslyRentedChange,
  currentResidence,
  previousResidence,
  pets,
  vehicles,
  hasVehicles,
  onHasVehiclesChange,
  onCurrentResidenceChange,
  onPreviousResidenceChange,
  onPetsChange,
  onVehicleChange,
}) => {
  return (
    <>
      <hr className="my-4" />

      <h5 className="mb-3">Landlord Information</h5>

      <div className="mb-4">
        <label className="form-label fw-semibold">Are you currently renting?</label>
        <div className="d-flex gap-4 mt-1">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="isCurrentlyRenting"
              id="rentingYes"
              checked={isCurrentlyRenting === true}
              onChange={() => onIsCurrentlyRentingChange(true)}
            />
            <label className="form-check-label" htmlFor="rentingYes">Yes</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="isCurrentlyRenting"
              id="rentingNo"
              checked={isCurrentlyRenting === false}
              onChange={() => onIsCurrentlyRentingChange(false)}
            />
            <label className="form-check-label" htmlFor="rentingNo">No</label>
          </div>
        </div>
      </div>

      {isCurrentlyRenting === true && (
        <>
          <h6 className="mb-3 text-muted">Current Landlord</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Present Landlord Name</label>
              <input
                type="text"
                className="form-control"
                value={currentResidence.landlordName}
                onChange={(e) =>
                  onCurrentResidenceChange("landlordName", e.target.value)
                }
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Landlord Address</label>
              <input
                type="text"
                className="form-control"
                value={currentResidence.landlordAddress}
                onChange={(e) =>
                  onCurrentResidenceChange("landlordAddress", e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Landlord Phone</label>
              <PhoneInput
                value={currentResidence.landlordPhone}
                onChange={(val) => onCurrentResidenceChange("landlordPhone", val)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">How long at this address</label>
              <input
                type="text"
                className="form-control"
                value={currentResidence.howLongAtAddress}
                onChange={(e) =>
                  onCurrentResidenceChange("howLongAtAddress", e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Rental Rate (TTD)</label>
              <input
                type="number"
                min="0"
                className="form-control"
                value={currentResidence.rentalRate}
                onChange={(e) =>
                  onCurrentResidenceChange("rentalRate", e.target.value)
                }
              />
            </div>
            <div className="col-12">
              <label className="form-label">Reason for Leaving</label>
              <textarea
                className="form-control"
                rows="2"
                value={currentResidence.reasonForLeaving}
                onChange={(e) =>
                  onCurrentResidenceChange("reasonForLeaving", e.target.value)
                }
              />
            </div>
          </div>
        </>
      )}

      <div className="mb-4 mt-4">
        <label className="form-label fw-semibold">Have you rented before current residence?</label>
        <div className="d-flex gap-4 mt-1">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasPreviouslyRented"
              id="prevRentingYes"
              checked={hasPreviouslyRented === true}
              onChange={() => onHasPreviouslyRentedChange(true)}
            />
            <label className="form-check-label" htmlFor="prevRentingYes">Yes</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasPreviouslyRented"
              id="prevRentingNo"
              checked={hasPreviouslyRented === false}
              onChange={() => onHasPreviouslyRentedChange(false)}
            />
            <label className="form-check-label" htmlFor="prevRentingNo">No</label>
          </div>
        </div>
      </div>

      {hasPreviouslyRented === true && (
        <>
          <h6 className="mb-3 text-muted">Previous Landlord</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Previous Landlord Name</label>
              <input
                type="text"
                className="form-control"
                value={previousResidence.landlordName}
                onChange={(e) =>
                  onPreviousResidenceChange("landlordName", e.target.value)
                }
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Previous Landlord Address</label>
              <input
                type="text"
                className="form-control"
                value={previousResidence.landlordAddress}
                onChange={(e) =>
                  onPreviousResidenceChange("landlordAddress", e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Previous Landlord Phone</label>
              <PhoneInput
                value={previousResidence.landlordPhone}
                onChange={(val) => onPreviousResidenceChange("landlordPhone", val)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">How long at last address</label>
              <input
                type="text"
                className="form-control"
                value={previousResidence.howLongAtAddress}
                onChange={(e) =>
                  onPreviousResidenceChange("howLongAtAddress", e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Reason for leaving</label>
              <input
                type="text"
                className="form-control"
                value={previousResidence.reasonForLeaving}
                onChange={(e) =>
                  onPreviousResidenceChange("reasonForLeaving", e.target.value)
                }
              />
            </div>
          </div>
        </>
      )}

      <hr className="my-4" />

      <h5 className="mb-3">Other</h5>

      <div className="mb-4">
        <label className="form-label fw-semibold">Do you have any pets?</label>
        <div className="d-flex gap-4 mt-1">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasPets"
              id="petsYes"
              checked={pets.hasPets === true}
              onChange={() => onPetsChange("hasPets", true)}
            />
            <label className="form-check-label" htmlFor="petsYes">Yes</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasPets"
              id="petsNo"
              checked={pets.hasPets === false}
              onChange={() => onPetsChange("hasPets", false)}
            />
            <label className="form-check-label" htmlFor="petsNo">No</label>
          </div>
        </div>
      </div>

      {pets.hasPets === true && (
        <div className="row g-3 mb-4">
          <div className="col-md-6">
            <label className="form-label">Type of Pets</label>
            <input
              type="text"
              className="form-control"
              value={pets.type}
              onChange={(e) => onPetsChange("type", e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">How many</label>
            <input
              type="number"
              min="0"
              className="form-control"
              value={pets.count}
              onChange={(e) => onPetsChange("count", e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="mb-4">
        <label className="form-label fw-semibold">Do you have any vehicles that need parking?</label>
        <div className="d-flex gap-4 mt-1">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasVehicles"
              id="vehiclesYes"
              checked={hasVehicles === true}
              onChange={() => onHasVehiclesChange(true)}
            />
            <label className="form-check-label" htmlFor="vehiclesYes">Yes</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="hasVehicles"
              id="vehiclesNo"
              checked={hasVehicles === false}
              onChange={() => onHasVehiclesChange(false)}
            />
            <label className="form-check-label" htmlFor="vehiclesNo">No</label>
          </div>
        </div>
      </div>

      {hasVehicles === true && (
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">How many</label>
            <input
              type="number"
              min="0"
              className="form-control"
              value={vehicles[0]?.count || ""}
              onChange={(e) => onVehicleChange(0, "count", e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Vehicle Type</label>
            <input
              type="text"
              className="form-control"
              value={vehicles[0]?.type || ""}
              onChange={(e) => onVehicleChange(0, "type", e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Plate Number</label>
            <input
              type="text"
              className="form-control"
              value={vehicles[0]?.plateNumber || ""}
              onChange={(e) => onVehicleChange(0, "plateNumber", e.target.value)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default LandlordPetsStep;
